import React from 'react';
import './Badge.css';

/**
 * Universal Badge Component
 * @param {string} variant - primary, success, warning, error, neutral, outline
 * @param {string} icon - FontAwesome class (e.g. "fas fa-check")
 * @param {string} className - Additional CSS classes
 */
export default function Badge({ 
  children, 
  variant = 'neutral', 
  icon,
  className = '', 
  ...props 
}) {
  return (
    <span
      className={`ui-badge variant-${variant} ${className}`}
      {...props}
    >
      {icon && <i className={icon}></i>}
      {children}
    </span>
  );
}
